<template>
  <div>
    <el-row
      class="flex-container-balance"
      style="padding-bottom: 0px; margin-bottom: 0px"
    >
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <CardTotal
          text="Tarjetas con inconvenientes"
          icon="el-icon-bank-card danger-text"
          :total="tarjetasConProblemas"
          :loading.sync="Loading"
        >
        </CardTotal>
      </el-col>

      <el-col :span="20">
        <el-row type="flex" justify="end">
          <el-col :span="10" :offset="1">
            <el-select
              size="large"
              v-model="proveedor"
              :loading="this.loading_Balance_Data"
              filterable
              clearable
              placeholder="Proveedores"
              @change="GetClintesByEmpresaid"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in proveedores"
                :key="index"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-select
              :disabled="!this.proveedor"
              size="large"
              v-model="cliente"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Clientes"
              @change="this.setCliente"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in clientes"
                :key="index"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        class="Table"
        :data="tableData1"
        v-loading="Loading"
        style="width: 100%"
      >
        <el-table-column props="acciones" label="Acciones" width="180">
          <template slot-scope="scope">
            <el-popover trigger="click" placement="left">
              <a @click="($event) => openVerDetallesDrawer(scope.row.Tarjeta)"
                >-Detalle Tarjeta</a
              >
              <hr />
              <a @click="($event) => openAuditoria(scope.row.Tarjeta)"
                >-Auditoria Tarjeta</a
              >
              <hr />
              <a>-Arreglar Balance</a>
              <div slot="reference" class="name-wrapper">
                <el-tag> <i class="el-icon-more"></i></el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="Tarjeta" label="No.Tarjeta" width="180">
        </el-table-column>
        <el-table-column
          style="color: red"
          prop="Nombre"
          label="Nombre"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="Balance_calculado"
          label="Balance Calculado"
          width="180"
        >
          <template slot-scope="scope">
            <a @click="HandleVisible(scope.row.Tarjeta)">{{
              format(scope.row.Balance_calculado)
            }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="Balance_BD" label="Balance BD" width="180">
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.Balance_BD == scope.row.Balance_calculado
                  ? 'success'
                  : 'danger'
              "
              >{{ format(scope.row.Balance_BD) }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="Tipo_control"
          label="Tipo de control"
          width="180"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Tipo_control === 'Controlada' ? 'warning' : ''"
              >{{ scope.row.Tipo_control }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="Tipo_consumo"
          label="Tipo de consumo"
          width="180"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Tipo_consumo === 'Monto' ? 'danger' : 'warning'"
              >{{ scope.row.Tipo_consumo }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[10, 200, 300, 400]"
        :page-size="10"
        layout="sizes, prev, pager, next"
        :total="registrosTotal"
      >
      </el-pagination>
    </el-row>

    <DrawerBalanceReport
      :Visible="IsVisible"
      @VisibleFalse="HandleNotVisible"
      :Cliente="cliente"
      :Tarjeta="Tarjetaid"
      :Dias="40"
    >
    </DrawerBalanceReport>
    <CardAuditoria
      :Visible="IsVisibleAuditoria"
      @VisibleFalse="closeAuditoria"
      :proveedor="proveedor"
      :cliente="cliente"
      :tarjeta="Tarjetaid"
    >
    </CardAuditoria>
    <detalles-tarjeta
      :tarjetaid="Tarjetaid"
      :open="verDetallesDrawerOpen"
      @VisibleFalse="HandleNotVisibleDetalles"
      :cliente="cliente"
      :proveedor="proveedor"
    ></detalles-tarjeta>
  </div>
</template>

<script>
import CardTotal from "@/components/CardTotalOriginal.vue";
import DrawerBalanceReport from "./DrawerBalanceReport.vue";
import DetallesTarjeta from "./DetallesTarjeta.vue";
import CardAuditoria from "./CardAuditoria.vue";
export default {
  name: "CardBalanceReport",
  components: {
    CardTotal,
    DrawerBalanceReport,
    DetallesTarjeta,
    CardAuditoria
  },
  data() {
    return {
      verDetallesDrawerOpen: false,
      tarjetasConProblemas: 0,
      IsVisibleAuditoria: false,
      Loading: false,
      totalDeRegistrosPorPagina: 10,
      paginaActual: 1,
      registrosTotal: 0,
      clientes: [],
      cliente: null,
      loading_Balance_Data: false,
      proveedor: undefined,
      proveedores: [],
      currentPage2: 1,
      tableData1: [],
      IsVisible: false,
      Tarjetaid: ""
    };
  },
  async mounted() {
    await this.getProveedor();
  },

  methods: {
    openVerDetallesDrawer(tarjetaid) {
      this.Tarjetaid = tarjetaid;
      this.verDetallesDrawerOpen = true;
    },
    format(price) {
      return new Intl.NumberFormat("en-US").format(price);
    },

    handleCurrentChange(val) {
      this.paginaActual = val;
      this.GetCardBalanceReport();
      this.currentPage2 = this.paginaActual;
    },
    handleSizeChange(val) {
      this.totalDeRegistrosPorPagina = val;
      this.GetCardBalanceReport();
    },
    HandleVisible(tarjetaid) {
      this.IsVisible = true;
      this.Tarjetaid = tarjetaid;
    },
    HandleNotVisible(value) {
      this.IsVisible = value;
    },
    openAuditoria(tarjetaid) {
      this.IsVisibleAuditoria = true;
      this.Tarjetaid = tarjetaid;
    },
    closeAuditoria() {
      this.IsVisibleAuditoria = false;
    },
    HandleNotVisibleDetalles() {
      this.verDetallesDrawerOpen = false;
    },
    async GetClintesByEmpresaid() {
      this.loading_Balance_Data = true;
      this.clientes = [];

      this.$http
        .get(`/api/tennos/GetClientByEmpresaId/?EmpresaId=${this.proveedor}`)
        .then((resp) => {
          resp.data.forEach((element) => {
            this.clientes.push({
              Name: element.Nombre_Cliente,
              id: element.clienteid
            });
          });
          this.loading_Balance_Data = false;
        });
      this.cliente = null;
    },
    async GetCardBalanceReport() {
      this.Loading = true;
      this.tableData1 = [];
      this.$http
        .get(
          `/api/tennos/GetCardBalanceReport/?ClienteId=${this.cliente}&ProveedorId=${this.proveedor}&Page=${this.paginaActual}&recordsPerPage=${this.totalDeRegistrosPorPagina}`
        )
        .then((resp) => {
          this.tarjetasConProblemas = resp.data.tarjetasConProblemas;

          this.registrosTotal = resp.data.total;
          resp.data.cards.forEach((element) => {
            if (element.Nombre == null) {
              element.Nombre = "Tarjeta Sin Nombre";
            }
            this.tableData1.push(element);
          });
          this.Loading = false;
        });
    },
    async getProveedor() {
      this.loading_Balance_Data = true;
      this.$http
        .get(`/api/tennos/GetEmpresas`)
        .then((resp) => {
          resp.data.forEach((element) => {
            this.proveedores.push({
              Name: element.Name,
              id: element.Empresaid
            });
          });
          this.loading_Balance_Data = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    setCliente() {
      this.paginaActual = 1;
      this.currentPage2 = this.paginaActual;
      this.GetCardBalanceReport();
    }
  },
  watch: {
    cliente() {
      this.paginaActual = 1;
    }
  }
};
</script>

<style lang="css" scoped>
.el-table td {
  color: red;
}
.flex-container-balance {
  display: flex;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  width: 100%;
}
.Table {
  margin-top: 3rem;
}
</style>
